import type { ReactNode } from "react";

interface TrendBadgeProps {
  trend: "rise" | "fall" | "steady";
  rate: number;
}

export function TrendBadge({ trend, rate }: TrendBadgeProps) {
  const map = {
    rise: { icon: "ri-arrow-up-line", cls: "text-primary-600 bg-primary-50", label: "热度上升" },
    fall: { icon: "ri-arrow-down-line", cls: "text-secondary-700 bg-secondary-50", label: "热度回落" },
    steady: { icon: "ri-subtract-line", cls: "text-accent-700 bg-accent-50", label: "热度持平" },
  } as const;
  const item = map[trend];
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-label whitespace-nowrap ${item.cls}`}
      title={item.label}
    >
      <span className="w-3 h-3 flex items-center justify-center">
        <i className={item.icon} />
      </span>
      {rate > 0 ? "+" : ""}
      {rate}%
    </span>
  );
}

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  children?: ReactNode;
}

export function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  children,
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`flex flex-col ${
        isCenter ? "items-center text-center" : "items-start"
      } gap-3 mb-8 md:mb-10`}
    >
      <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.2em] text-primary-600 uppercase">
        <span className="w-6 h-px bg-primary-400" />
        {eyebrow}
      </span>
      <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight max-w-3xl">
        {title}
      </h2>
      {desc && (
        <p className={`text-sm md:text-base text-foreground-600 leading-relaxed ${isCenter ? "max-w-2xl mx-auto" : "max-w-2xl"}`}>
          {desc}
        </p>
      )}
      {children}
    </div>
  );
}